module.exports = __webpack_public_path__ + "img/check.d595ca71.svg";